import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import BudgetActions from "../../../../reducers/modules/accounting/budget/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";
import i18n from "../../../../i18n";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "accounting/budget";

export default class BudgetMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(BudgetActions.create());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(BudgetActions.update());
      BudgetMiddleware.showOne(dispatch, params);
    };
  }

  static beforeApprove(id, value, search) {
      const post = {
        id: id,
        value: value,
      };
      return (dispatch) => {
        dispatch(BudgetActions.approve());
        BudgetMiddleware.saveApprove(dispatch, post, search);
      };
    }
  
    static beforeReject(id, value, search) {
      const post = {
        id: id,
        value: value,
      };
      return (dispatch) => {
        dispatch(BudgetActions.reject());
        BudgetMiddleware.saveReject(dispatch, post, search);
      };
    }
  

  static list(params) {
    return (dispatch) => {
      dispatch(BudgetActions.process());
      BudgetMiddleware.showlist(dispatch, params);
    };
  }

  static reset() {
    return (dispatch) => {
      dispatch(BudgetActions.reset());
    };
  }

  static resetList() {
    return (dispatch) => {
      dispatch(BudgetActions.resetList());
    };
  }

  static getOne(params) {
    return (dispatch) => {
      dispatch(BudgetActions.view());
      BudgetMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(BudgetActions.submit());
      BudgetMiddleware.saveNew(dispatch, post, search);
    };
  }

  static beforeUploadNew(post, search) {
    return (dispatch) => {
      dispatch(BudgetActions.submit());
      BudgetMiddleware.uploadNew(dispatch, post, search);
    };
  }

  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(BudgetActions.submit());
      BudgetMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }

  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(BudgetActions.void());
      BudgetMiddleware.delete(dispatch, params, id);
    };
  }

  static beforeVoid(id, params) {
    return (dispatch) => {
      dispatch(BudgetActions.void());
      BudgetMiddleware.voidData(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      BudgetMiddleware.showHelper(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

   static saveApprove(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BudgetMiddleware.getToken()}`,
      },
      url: url + "/approve/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BudgetActions.process(),
            BudgetMiddleware.showlist(dispatch, search)
          );
          dispatch(BudgetActions.success());
          BudgetMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Approve Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BudgetMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveReject(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BudgetMiddleware.getToken()}`,
      },
      url: url + "/reject/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BudgetActions.process(),
            BudgetMiddleware.showlist(dispatch, search)
          );
          dispatch(BudgetActions.success());
          BudgetMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Reject Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BudgetMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BudgetMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(BudgetActions.list(response.data.result));
        }
      })
      .catch((error) => {
        BudgetMiddleware.alertHendler(dispatch, error);
      });
  }

  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BudgetMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-budget",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(BudgetActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        BudgetMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BudgetMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BudgetActions.process(),
            BudgetMiddleware.showlist(dispatch, params)
          );
          BudgetMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BudgetMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static voidData(dispatch, params, id, ) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BudgetMiddleware.getToken()}`,
      },
      url: url + "/cancel/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BudgetActions.process(),
            BudgetMiddleware.showlist(dispatch, params)
          );
          BudgetMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Cancel Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BudgetMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {

    const formData = new FormData();

    // Tambahkan semua key dari Budget
    Object.entries(post.Budget).forEach(([key, value]) => {
      if (key === "images") {
        // kalau ada file, loop satu per satu
        for (let i = 0; i < value.length; i++) {
          formData.append(`Budget[images][${i}]`, value[i]);
        }
      } else {
        formData.append(`Budget[${key}]`, value);
      }
    });

    // tambahkan timezone kalau ada
    if (post.timezone) formData.append('timezone', post.timezone);

    axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${BudgetMiddleware.getToken()}`,
      },
      url: url,
      data: formData,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BudgetActions.process(),
            BudgetMiddleware.showlist(dispatch, search)
          );
          dispatch(BudgetActions.success());
          BudgetMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Save Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BudgetMiddleware.alertHendler(dispatch, error);
      });
  }

  static uploadNew(dispatch, post, search) {
    const formData = new FormData();
    formData.append('file', post.Upload.file);     
    formData.append('branch', post.Upload.idBranch); 
    formData.append('tanggal', post.Upload.date);
    formData.append('store', post.Upload.idStore);
    formData.append('warehouse', post.Upload.idWarehouse);
    axios({
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        Authorization: `Bearer ${BudgetMiddleware.getToken()}`,
      },
      url: url + '/upload',
      data: formData,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BudgetActions.process(),
            BudgetMiddleware.showlist(dispatch, search)
          );
          dispatch(BudgetActions.success());
          BudgetMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Save Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BudgetMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${BudgetMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BudgetActions.process(),
            BudgetMiddleware.showlist(dispatch, search)
          );
          dispatch(BudgetActions.success());
          BudgetMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BudgetMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              console.log(data)
              MySwal.hideLoading();
              MySwal.update({
                title: "Error",
                html: i18n.t(data.message),
                icon: "error",
                showConfirmButton: true,
              })
              const search = {limit: 10}
                dispatch(
                  BudgetActions.process(),
                  BudgetMiddleware.showlist(dispatch, search)
                );
          
            } else {
              const data = result.response.data;
              dispatch(BudgetActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(BudgetActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
